import classNames from "classnames";
import styles from "./SectionHeader.module.css";
import React from "react";

//#region [Component]
export interface SectionHeaderProps extends React.HTMLAttributes<HTMLHeadingElement> {
    children: React.ReactNode;
    as?: React.ElementType;
}

export default function SectionHeader({ children, className = "", as: Tag = "h1", ...props }: SectionHeaderProps) {
    return (
        <Tag className={classNames(styles.sectionHeader, className)} {...props}>
            {children}
        </Tag>
    );
}
//#endregion